
<TextField
  :id="id"
  v-model="content"
  :name="name"
  :labelName="labelName"
  type="email"
  autocomplete="email"
  :helperText="emailHelperText"
  :status="emailStatus"
  @blur="validateEmail"
/>
